import { useLocation, Outlet } from "react-router-dom";
import styles from "./Shell.module.css";
import { Header } from "./Header";
import { ProgressBar } from "./ProgressBar";
import { isHomePath } from "../../routes";

export function Shell() {
  const location = useLocation();
  const isHome =
    isHomePath(location.pathname) ||
    location.pathname === "/classic" ||
    location.pathname === "/csp";

  return (
    <div className={styles.shell}>
      <Header hidden={isHome} />
      <main className={styles.content}>
        <Outlet />
      </main>
      <ProgressBar hidden={isHome} />
    </div>
  );
}
